import { render, staticRenderFns } from "./RegistrationPrint.vue?vue&type=template&id=d2820998&"
import script from "./RegistrationPrint.vue?vue&type=script&lang=js&"
export * from "./RegistrationPrint.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPrint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VDataTable,VFlex,VLayout,VMain,VTextarea})
